import { createSignal, onMount, Show } from "solid-js";
import { ArtworksTab } from "./ArtworksTab";
import { DepictedPlacesTab } from "./DepictedPlacesTab";
import { CMS } from "./cms";
import { GoogleMapsProvider } from "./GoogleMapsProvider";
import { createStore } from "solid-js/store";
import { cleanImagePath, fetchGet } from "./API";
import { Resources } from "./Data";
import { NearbyMuseumsTab } from "./NearbyMuseumsTab";
import { ArtworkLocation, ArtworkLocationImage, UserSession } from "./Types";
import { MoreImagesTab } from "./MoreImagesTab";

type TabName = "artworks"|"videos"|"articles"|"library"|"albums"|"depicted-places"|"nearby-museums"|"images";

type State = {
    isContentReady: boolean;
}

function App(props: any) {
    const [session, setSession] = createStore<UserSession>({ } as any);
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [tab, setTab] = createSignal<TabName>("artworks");
    const [data, setData] = createStore<ArtworkLocation>({} as ArtworkLocation);
    const [heroImage, setHeroImage] = createSignal<ArtworkLocationImage|null>(null);
    const loadSession = async () => {
        const response = await fetch("/Home/GetAuthenticatedUserJson");
        const json = await response.json();
        if (!json.Success) {
            return;
        }
        setSession(json.Data);
    };
    const loadArtworkLocation = async () => {
        const res = await fetchGet("/ArtCollection/FindJson", { id: props.id });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        setData(json.Data);
        const hero = data.Images?.find(x => x.ImageRole == "artwork-location-hero-image");
        if (hero) {
            setHeroImage(hero);
        }
    };
    onMount(async() => {
        await loadSession();
        await loadArtworkLocation();
        setState({ isContentReady: true });
    });
    return (
        <>
            <GoogleMapsProvider apiKey={props.googleMapsApiKey}>
                <Show when={state.isContentReady}>
                    <div class="container" style="text-align: center;">
                        <p class="name" style="font-size: 4rem;">
                            {data.Name}
                        </p>
                    </div>
                    <Show when={heroImage()}>
                        <div>
                            <img src={cleanImagePath(heroImage()!.URL) + "?mode=crop&width=1600"} style="width: 100%; max-height: 500px;" />
                        </div>
                    </Show>
                    <div class="container" style="text-align: center;">
                        <p class="attributes">
                            {data.Address1}<br/>
                            {data.Address2}
                        </p>
                        <p style="font-size: 2em;line-height: 2em;">
                            {[data.City, data.State, data.Country].filter(x => !!x).join(", ")}
                        </p>
                    </div>
                    <section id="main-template" class="tabs air-gap">
                        <ul class="list-inline tablinkgroup unselectable">
                            <li onClick={() => setTab("artworks")} classList={{ ["active"]: tab() == "artworks"}}>
                                <span class="tablink">
                                    <CMS id="tab::artists">Artworks</CMS>
                                </span>
                            </li>
                            <Show when={data.HasVideos}>
                                <li onClick={() => setTab("videos")} classList={{ ["active"]: tab() == "videos"}}>
                                    <span class="tablink">
                                        <CMS id="tab::artists">Videos</CMS>
                                    </span>
                                </li>
                            </Show>
                            <Show when={data.HasAlbums}>
                                <li onClick={() => setTab("albums")} classList={{ ["active"]: tab() == "albums"}}>
                                    <span class="tablink">
                                        <CMS id="tab::artists">Albums</CMS>
                                    </span>
                                </li>
                            </Show>
                            <Show when={data.Images.length}>
                                <li onClick={() => setTab("images")} classList={{ ["active"]: tab() == "images"}}>
                                    <span class="tablink">
                                        <CMS id="tab::artists">Images</CMS>
                                    </span>
                                </li>
                            </Show>
                            <Show when={data.HasDepictedPlaces}>
                                <li onClick={() => setTab("depicted-places")} classList={{ ["active"]: tab() == "depicted-places"}}>
                                    <span class="tablink">
                                        <CMS id="tab::artists">Depicted Places</CMS>
                                    </span>
                                </li>
                            </Show>
                            <li onClick={() => setTab("nearby-museums")} classList={{ ["active"]: tab() == "nearby-museums"}}>
                                <span class="tablink">
                                    <CMS id="tab::artists">Nearby Museums</CMS>
                                </span>
                            </li>
                        </ul>
                        <div class="tabgroup">
                            <Show when={tab() == "artworks"}>
                                <div class="tab-pane active">                                
                                    <ArtworksTab
                                        session={session}
                                        artworkLocationId={props.id}
                                        isLoggedIn={false}
                                        hasMapLocations={true}
                                        resources={{ countries: Resources.countries, artworkTypes: Resources.artworkTypes }}
                                    />
                                </div>                        
                            </Show>
                            <Show when={tab() == "videos"}>
                                <div class="tab-pane active">
                                    
                                </div>                          
                            </Show>
                            <Show when={tab() == "images"}>
                                <div class="tab-pane active">
                                    <MoreImagesTab data={data} />
                                </div>                          
                            </Show>
                            <Show when={tab() == "albums"}>
                                <div class="tab-pane active">
                                    {/* <AlbumsTab artworkLocationId={id}></AlbumsTab> */}
                                </div>                          
                            </Show>
                            <Show when={tab() == "depicted-places"}>
                                <div class="tab-pane active">
                                    <DepictedPlacesTab onBackToArtworksClicked={() => setTab("artworks")} data={data} />
                                </div>                          
                            </Show>
                            <Show when={tab() == "nearby-museums"}>
                                <div class="tab-pane active">
                                    <NearbyMuseumsTab onBackToArtworksClicked={() => setTab("artworks")} data={data} />
                                </div>                          
                            </Show>
                        </div>
                    </section>
                </Show>
            </GoogleMapsProvider>
        </>
    );
}
export default App;